import React from 'react';

export interface IAttestMessageContext {
  messageEditModeID: string;
  messageReciverID: string | undefined;
  setMessageEditModeID: React.Dispatch<React.SetStateAction<string>>;
  setMessageReciverID: React.Dispatch<React.SetStateAction<string | undefined>>;
  setHaveAttesterat: React.Dispatch<React.SetStateAction<boolean>>;
}

const defaults: IAttestMessageContext = {
  messageEditModeID: '',
  messageReciverID: '',
  setMessageEditModeID: () => {},
  setMessageReciverID: () => {},
  setHaveAttesterat: () => {},
};

const AttestMessageContext =
  React.createContext<IAttestMessageContext>(defaults);

export const AttestMessageContextProvider = AttestMessageContext.Provider;

export default AttestMessageContext;
